qw-room-rate {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: var(--qw-hotel-gap-sm);
}

.qw-room-rate__title {
  width: 35%;
}

.qw-room-rate__price {
  width: 18%;
  display: flex;
  flex-direction: column;
}

.qw-room-rate__price-crossed {
  font-size: var(--qw-hotel-small-font-size);
  color: var(--qw-hotel-neutral-medium);
  text-decoration: line-through;
}

.qw-room-rate__taxes {
  font-size: var(--qw-hotel-small-font-size);
}

qw-room-rate label {
  width: 20%;
  text-align: center;
}

qw-room-rate .qw-button {
  width: 25%;
}

.qw-room-rate__conditions {
  padding: var(--qw-hotel-gap-md);
  width: 100%;
  font-size: var(--qw-hotel-small-font-size);
}

.qw-room-rate__conditions-content p {
  margin: 0;
}

.qw-room-rate__occupancy {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
}

.qw-room-rate__occupancy span {
  width: 20px;
  height: 25px;
  background: url('https://hotels-booking-engine.qwentes.it/versions/v1/img/person.svg') no-repeat bottom;
  background-size: 17px 18px;
}

.qw-room-rate__occupancy span.child {
  width: 20px;
  height: 25px;
  background: url('https://hotels-booking-engine.qwentes.it/versions/v1/img/person.svg') no-repeat bottom;
  background-size: 17px 15px;
}

.qw-room-rate__occupancy span.infant {
  width: 20px;
  height: 25px;
  background: url('https://hotels-booking-engine.qwentes.it/versions/v1/img/person.svg') no-repeat bottom;
  background-size: 17px 12px;
}

.qw-room-rate__counter {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.qw-room-rate__counter-label, .qw-room-rate__counter-availability {
  font-size: 70%;
}

.qw-select__quantity, .qw-select__quantity .qw-select__label {
  width: 100%;
}

.qw-room-rate--card {
  position: relative;
  min-width: var(--qw-room-rate--card--min-width);
  max-width: var(--qw-room-rate--card--max-width);
  min-height: var(--qw-room-rate--card--min-height);
  margin-right: var(--qw-hotel-gap-sm);
  padding: var(--qw-hotel-gap-sm);
  border: 2px solid var(--qw-hotel-neutral-medium);
  flex-direction: column;
}

.qw-room-rate--card .qw-room-rate__title,
.qw-room-rate--card .qw-room-rate__price {
  width: 100%;
}

.qw-room-rate--card .qw-room-rate__conditions {
  order: 2;
}

.qw-room-rate__counter-add-to-basket {
  display: flex;
  justify-content: space-between;
  order: 3;
}

.qw-room-rate__counter-add-to-basket .qw-button {
  width: 40%;
}

.qw-room-rate__is-adding-to-basket {
  opacity: var(--qw-hotel-opacity);
  pointer-events: none !important;
}

.qw-room-rate__info {
  width: 20px;
  height: 20px;
  background: url('https://hotels-booking-engine.qwentes.it/versions/v1/img/icons/info.svg') no-repeat center;
  background-size: 20px 20px;
  border: 1px solid var(--qw-hotel-neutral-medium);
  border-radius: 50%;
  position: absolute;
  top: var(--qw-hotel-gap-sm);
  right: var(--qw-hotel-gap-sm);
  cursor: pointer;
}

.qw-room-rate__info:hover + .qw-room-rate__other-conditions-popup {
  display: block;
}

.qw-room-rate__other-conditions-popup {
  display: none;
  position: absolute;
  background: var(--qw-hotel-neutral-medium);
  padding: var(--qw-hotel-gap-sm);
  top: 36px;
  left: var(--qw-hotel-gap-sm);
  right: var(--qw-hotel-gap-sm);
  font-size: var(--qw-hotel-small-font-size);
}

.qw-room-rate__highlight .qw-room-rate__title-name {
  font-weight: bold;
}

.qw-room-rate__package-trigger {
  cursor: pointer;
  margin-top: var(--qw-hotel-gap-md);
}

.qw-room-rate__package-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  z-index: 10;
}

.qw-room-rate__package-content {
  position: relative;
  width: 70%;
  min-height: 50%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: var(--qw-hotel-gap-md);
  background-color: var(--qw-hotel-neutral-lightest);
}

.qw-room-rate__package-info {
  width: 58%;
  flex-grow: 1;
  margin-right: var(--qw-hotel-gap-md);
}

.qw-room-rate__package-image {
  width: 39%;
  margin-top: 50px;
}

.qw-room-rate__package-image img {
  width: 100%;
}

.qw-room-rate__package-info .qw-room-rate__package-actions {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.qw-room-rate__package-close {
  position: absolute;
  top: var(--qw-hotel-gap-md);
  right: var(--qw-hotel-gap-md);
  background: var(--qw-hotel-secondary-color);
  width: 30px !important;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
